import { ExpertCard } from "@calcom/features/experts/components/ExpertCard";
import { Hero } from "@components/ui/Hero";
import type { inferSSRProps } from "@lib/types/inferSSRProps";
import { getNextAvailableSlotForExpert } from "helpers/getNextAvailableSlotForExpert";
import { fetchExpertAndBookingData, fetchScheduleData } from "@lib/experts/api";

export type ExpertsPageProps = inferSSRProps<typeof getStaticProps>;

function ExpertsPage({ experts, booking, slots }: ExpertsPageProps) {
  const expertsNextAvailableSlot = getNextAvailableSlotForExpert(experts, slots);

  return (
    <>
      <Hero>
        <div className="container relative py-12 md:py-32">
          <h1 className="text-5xl md:text-6xl">Experts</h1>
          <p className="mt-4 max-w-3xl text-2xl leading-normal">
            Our team of consultants is like a delicious blend of different flavours - we&apos;ve got tech
            leaders, social scientists, and marketing masterminds all working together. With each member
            bringing at least 10 years of experience to the table, we&apos;re equipped to tackle any challenge
            and help you achieve your goals.
          </p>
        </div>
      </Hero>
      <div className="container">
        <hr className="border-brand-500" />
      </div>
      <main>
        <div className="container py-12 md:py-32">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-10">
            {experts.map((expert) => (
              <ExpertCard
                key={expert.id}
                booking={booking}
                expert={expert}
                nextAvailableSlot={expert.username ? expertsNextAvailableSlot[expert.username] : null}
              />
            ))}
          </div>
        </div>
      </main>
    </>
  );
}

export const getStaticProps = async () => {
  try {
    const { booking, experts } = await fetchExpertAndBookingData();
    const expertsList = experts.map((e) => e.username);
    const slots = await fetchScheduleData(expertsList, booking);

    return {
      props: {
        experts,
        booking,
        slots,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching data in getStaticProps:", error);
    return { notFound: true };
  }
};

export default ExpertsPage;
